import { CRITICAL_SCREEN_PERMISSION_MAP } from "../constants/permissionCatalog";

/**
 * Ordem ao escolher a primeira tela após login ou quando /dashboard não está liberada.
 * Alinhado ao menu principal (AppLayout).
 */
export const HOME_ROUTE_PRIORITY = [
  "/dashboard",
  "/gestao",
  "/nucleos-atividades",
  "/matriculas",
  "/gerenciamento-matriculas",
  "/operacoes",
  "/planejamentos",
  "/galeria",
  "/relatorios",
  "/perfil",
];

/**
 * Usa o mesmo mapa de telas críticas do ProtectedRoute.
 */
export function isPathGrantedByGranularScreenMap(pathname, hasEffectivePermission) {
  const required = CRITICAL_SCREEN_PERMISSION_MAP[pathname];
  if (!Array.isArray(required) || required.length === 0) {
    return true;
  }
  return required.some(code => hasEffectivePermission(code));
}

export function getFirstAccessibleAppPath({ granularPermissionsEnabled, hasEffectivePermission }) {
  if (!granularPermissionsEnabled) {
    return "/dashboard";
  }
  for (const path of HOME_ROUTE_PRIORITY) {
    if (isPathGrantedByGranularScreenMap(path, hasEffectivePermission)) {
      return path;
    }
  }
  return "/perfil";
}

/**
 * Após login ou refresh: respeita rota desejada apenas se o usuário tiver permissão;
 * caso contrário, usa a primeira rota acessível (ex.: Galeria).
 */
export function resolvePostLoginPath({ granularPermissionsEnabled, hasEffectivePermission, preferredPath }) {
  if (!granularPermissionsEnabled) {
    if (typeof preferredPath === "string" && preferredPath.startsWith("/")) {
      return preferredPath;
    }
    return "/dashboard";
  }
  const clean = typeof preferredPath === "string" && preferredPath.startsWith("/") ? preferredPath : "";
  if (clean && isPathGrantedByGranularScreenMap(clean, hasEffectivePermission)) {
    return clean;
  }
  return getFirstAccessibleAppPath({ granularPermissionsEnabled, hasEffectivePermission });
}
